import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import './about.css';
import ReactCardFlip from 'react-card-flip';
import latest1 from "../../images/TRUST.png"
import Footer from '../footer/Footer';

function About() {
  const [flip, setFlip] = useState(false);
  const [flip1, setFlip1] = useState(false);
  const [flip2, setFlip2] = useState(false);
  const [flip3, setFlip3] = useState(false);
  const [flip4, setFlip4] = useState(false);
  const [flip5, setFlip5] = useState(false);
  const [flip6, setFlip6] = useState(false);
  const [flip7, setFlip7] = useState(false);
  const [flip8, setFlip8] = useState(false);
  const [flip9, setFlip9] = useState(false);

  const handleMouseEnter = () => {
    setFlip(true);
  };
  const handleMouseLeave = () => {
    setFlip(false);
  };
  const handleMouseEnter1 = () => {
    setFlip1(true);
  };
  const handleMouseLeave1 = () => {
    setFlip1(false);
  };
  const handleMouseEnter2 = () => {
    setFlip2(true);
  };
  const handleMouseLeave2 = () => {
    setFlip2(false);
  };
  const handleMouseEnter3 = () => {
    setFlip3(true);
  };
  const handleMouseLeave3 = () => {
    setFlip3(false);
  };
  const handleMouseEnter4 = () => {
    setFlip4(true);
  };
  const handleMouseLeave4 = () => {
    setFlip4(false);
  };
  const handleMouseEnter5 = () => {
    setFlip5(true);
  };
  const handleMouseLeave5 = () => {
    setFlip5(false);
  };
  const handleMouseEnter6 = () => {
    setFlip6(true);
  };
  const handleMouseLeave6 = () => {
    setFlip6(false);
  };
  const handleMouseEnter7 = () => {
    setFlip7(true);
  };
  const handleMouseLeave7 = () => {
    setFlip7(false);
  };
  const handleMouseEnter8 = () => {
    setFlip8(true);
  };
  const handleMouseLeave8 = () => {
    setFlip8(false);
  };
  const handleMouseEnter9 = () => {
    setFlip9(true);
  };
  const handleMouseLeave9 = () => {
    setFlip9(false);
  };
  const leaveThebox = () => {
    handleMouseLeave()
    handleMouseLeave1()
    handleMouseLeave2()
    handleMouseLeave3()
    handleMouseLeave4()
    handleMouseLeave5()
    handleMouseLeave6()
    handleMouseLeave7()
    handleMouseLeave8()
    handleMouseLeave9()
  }
  return (
    <>
      <Navbar />
      <div className='aboutmain'>
        <div className='aboutinner'>
          <h2>About Us</h2>
          <p>Welcome to Creative International, a distinguished institution specializing in the Import and Distribution of Premium Car Care products. We take pride in our accreditation and ISO 9001:2015 certification, symbolizing our commitment to excellence. As we celebrate 31 Years of Excellence, our team at Creative International stands as a benchmark in the industry, setting standards that are not just followed but revered.</p>
        </div>
      </div>

      <div className='aboutcore'>
        <div className='aboutheadingdiv'>
          <h2>Core values</h2>
          <div className='aboutline'></div>
        </div>

        <div className='aboutDiv'>
          <ReactCardFlip isFlipped={flip4} flipDirection="horizontal">
            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter4} onMouseLeave={handleMouseLeave4}>
              <img src={latest1}></img>
              <p className='flipfrontPara'>Quality</p>
            </div>

            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter4} onMouseLeave={handleMouseLeave4} onClick={() => leaveThebox()}>
              <p>Quality</p>
              <p style={{ fontSize: "12px", textTransform: 'capitalize', padding: '0px 10px',textAlign:'center' }}>Quality is never an accident; it is always the result of high intension, sincere effort, intelligent direction and skillfull execution; it represent the wise choice of many alternatives. we believe that QUALITY makes a lasting IMPRESSION. </p>

            </div>
          </ReactCardFlip>

          <ReactCardFlip isFlipped={flip5} flipDirection="horizontal">
            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter5} onMouseLeave={handleMouseLeave5}>
              <img src={latest1} alt='Core Values: Integrity in Coaching Classes'></img>
              <p className='flipfrontPara'>INTEGRITY</p>
            </div>

            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter5} onMouseLeave={handleMouseLeave5} onClick={() => leaveThebox()}>
              <p>INTEGRITY</p>
              <p style={{ fontSize: "12px", textTransform: 'capitalize', padding: '0px 10px',textAlign:'center' }}>integrity is doing the right thing, even if nobody is watching.</p>
            </div>
          </ReactCardFlip>


          <ReactCardFlip isFlipped={flip7} flipDirection="horizontal">
            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter7} onMouseLeave={handleMouseLeave7}>
              <img src={latest1}></img>
              <p className='flipfrontPara'>EXCELLENCE</p>
            </div>

            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter7} onMouseLeave={handleMouseLeave7} onClick={() => leaveThebox()}>
              <p>EXCELLENCE</p>
              <p style={{ fontSize: "12px", textTransform: 'capitalize', padding: '0px 10px',textAlign:'center' }}>Excellence is the unlimited ability to improve the quality of what you have to offer.</p>
            </div>
          </ReactCardFlip>
          <ReactCardFlip isFlipped={flip8} flipDirection="horizontal">
            <div className='aboutImgDiv hideFlip' onMouseEnter={handleMouseEnter8} onMouseLeave={handleMouseLeave8}>
              <img src={latest1} alt='Trust - Why Choose Our Coaching Classes'></img>
              <p className='flipfrontPara'>TRUST</p>
            </div>

            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter8} onMouseLeave={handleMouseLeave8} onClick={() => leaveThebox()}>
              <p>TRUST</p>
              <p style={{ fontSize: "12px", textTransform: 'capitalize', padding: '0px 10px',textAlign:'center' }}>Trust is an essential human value. like oil, trust is the lubrication that brings the members together and keeps team marching ahead to achieve success.</p>
            </div>
          </ReactCardFlip>

          <ReactCardFlip isFlipped={flip} flipDirection="horizontal">
            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <img src={latest1}></img>
              <p className='flipfrontPara'>Honesty</p>
            </div>

            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={() => leaveThebox()}>
              <p>Honesty</p>
              <p style={{ fontSize: "12px", textTransform: 'capitalize', padding: '0px 10px',textAlign:'center' }}>A honest person is who displays integrity, is genuine and not deceptive or fraudulent. honesty is characterized by truth and sincerity.</p>
            </div>
          </ReactCardFlip>

          <ReactCardFlip isFlipped={flip1} flipDirection="horizontal">
            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter1} onMouseLeave={handleMouseLeave1}>
              <img src={latest1}></img>
              <p className='flipfrontPara'>Respect for Individual</p>
            </div>

            <div className='aboutImgDiv' onMouseEnter={handleMouseEnter1} onMouseLeave={handleMouseLeave1} onClick={() => leaveThebox()}>
              <p>Respect for Individual</p>
              <p style={{ fontSize: "12px", textTransform: 'capitalize', padding: '0px 10px',textAlign:'center' }}>Respect for ourselves guides our morals; respect for others guides our manners.</p>
            </div>
          </ReactCardFlip>
        </div>
      </div>


      <Footer />
    </>
  )
}

export default About
